import { ANIMATION_TYPES } from '@website-editor/context/NavigationPaneContext/NavigationPane.constants';
import { CUSTOM_PAGE_ACTIONS } from '@website-editor/customComponents/CustomComponents.constants';

export enum PHOTO_GALLERY_ACTIONS {
  PHOTO_GALLERY_ADD = 'photo_gallery_add',
  PHOTO_GALLERY_EDIT = 'photo_gallery_edit',
}

export const PHOTO_GALLERY_SCREENS = [PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_ADD, PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_EDIT];

export const PHOTO_GALLERY_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [
    {
      navigatedFrom: PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD]: [
    {
      navigatedFrom: PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_ADD]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_EDIT]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
};
